// src/lib/evenements-maison.js — « CE QUI A UNE MAISON Y VA ».
//
// Dimitri, 2026-09-13 : « Un message s'annonce, puis rejoint "Messages en
// attente" et disparaît du fil — il n'existe plus qu'une fois. Si le fil existe
// déjà, la ligne remonte au lieu d'être dupliquée. Ce qui n'a pas de maison
// reste dans le fil, pour que je ne le rate pas si je n'étais pas devant. »
//
// ⚠️ LE TRI SE FAIT CÔTÉ ÉCRAN, et c'est la même règle que pour le relevé :
// seul l'écran sait ce qu'il affiche DÉJÀ. Le serveur annonce ce qui s'est
// passé ; il ne peut pas savoir que la ligne a trouvé sa place entre-temps.
//
// ⚠️ ET « AVOIR UNE MAISON » N'EST PAS « ÊTRE DE CETTE NATURE ». Un message
// dont le fil n'est PAS dans la liste (parce qu'on y a déjà répondu, ou parce
// qu'il est tu) reste dans le fil des annonces : le retirer sur sa seule
// nature le ferait disparaître des deux endroits à la fois. C'est exactement
// le défaut qu'on vient de passer deux jours à éliminer sur les listes.

/** Les natures qui ONT une maison ailleurs sur l'accueil, et laquelle. */
const MAISONS = Object.freeze({
  // Un message habite « Messages en attente » — donc, depuis le 2026-09-13,
  // la liste compacte derrière le point d'état.
  message: (ev, chez) => !!(ev.thread_id && chez.fils.has(ev.thread_id)),
  // Un ménage sans agent habite « Ce qui vous attend ».
  menage: (ev, chez) => !!(ev.run_id && chez.runs.has(ev.run_id)),
});

/**
 * @param {Array} evenements — ce que le serveur annonce
 * @param {{fils:Set<string>, runs:Set<string>}} chez — ce que l'écran affiche
 * @returns {Array} ce qui reste à annoncer, dans l'ordre reçu
 */
export function garderCeQuiNaPasDeMaison(evenements, chez) {
  const c = {
    fils: (chez && chez.fils) || new Set(),
    runs: (chez && chez.runs) || new Set(),
  };
  return (evenements || []).filter((ev) => {
    if (!ev) return false;
    const aUneMaison = MAISONS[ev.nature];
    if (!aUneMaison) return true;
    // ⚠️ CE QU'IL REMARQUE NE REJOINT JAMAIS UNE LISTE : personne ne l'a
    // déclenché, aucune carte ne l'attend. Le retirer parce qu'un fil du même
    // logement est affiché le ferait disparaître sans qu'il ait jamais été lu.
    if (ev.remarque) return true;
    return !aUneMaison(ev, c);
  });
}
